const _excluded = ["inputService", "isAddDisabled", "commitNewRowWhenValid"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { useEffect } from 'react';
import isEqual from 'react-fast-compare';
import { useOnClickOutside } from '../../../hooks/useOnClickOutside';
import { useInput } from '../../../machines/inputMachine/useInput';
import { CommandBar } from '../../CommandBar';
import { FieldErrorMessage } from '../../Validation/FieldErrorMessage';
import { InlineEditTable } from './InlineEditTable';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const InlineEditControl = _ref => {
  let {
      inputService,
      isAddDisabled,
      commitNewRowWhenValid
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const ref = React.useRef(null);
  if (!inputService) return /*#__PURE__*/_jsx("div", {
    children: "no input service defined"
  });
  const {
    value,
    send,
    errorMessage,
    touched,
    name
  } = useInput(inputService, true);
  useOnClickOutside([ref], _e => {
    setDraftItem(undefined);
    if (props.deselectOnClickOutside && document.getElementById('root')) {
      if (selectedRow === '-1') {
        setSelectedRow('0');
      }
      setSelectedRow('-1');
    }
  },
  //todo :WARNING this depends on app being hosted in a node with ID root.
  //find way to get top anscestor
  // wont cause crash
  //ref.current
  document.getElementById('root'));
  const [selectedRow, setSelectedRow] = React.useState();
  const [sortBy, setSortBy] = React.useState();
  const [hasIncompleteRow, setHasIncompleteRow] = React.useState(false);
  const [draftItem, setDraftItem] = React.useState();
  const committedRows = value !== null && value !== void 0 ? value : [];
  const rows = draftItem ? [...committedRows, draftItem] : committedRows;
  useEffect(() => {
    send({
      type: 'FOCUS'
    });
  }, []);
  useEffect(() => {
    let isCancelled = false;
    areAllRowsValid(rows, props.inputList, props.onValidation).then(isValid => {
      if (!isCancelled) setHasIncompleteRow(!isValid);
    });
    return () => {
      isCancelled = true;
    };
  }, [value, draftItem, props.onValidation]);
  useEffect(() => {
    if (props.addItem) {
      onAddItem(props.addItem);
    }
  }, [props.addItem]);
  const sendUpdate = updated => {
    send({
      type: 'CHANGE',
      value: updated
    });
    send({
      type: 'COMMIT'
    });
  };
  const onAddItem = data => {
    if (!props.preventClearSortOnAdd) {
      setSortBy([]);
    }
    const updated = value ? value.map(v => v) : [];
    const newItem = props.buildNewItem ? props.buildNewItem(updated) : data;
    if (commitNewRowWhenValid && newItem) {
      setDraftItem(newItem);
      setSelectedRow(updated.length.toString());
      return;
    }
    if (newItem) {
      updated.push(newItem);
    }
    sendUpdate(updated);
    setSelectedRow((updated.length - 1).toString());
  };
  const onDraftUpdate = async rowData => {
    const updatedDraft = _objectSpread(_objectSpread({}, draftItem), rowData);
    const isComplete = await areAllRowsValid([updatedDraft], props.inputList, props.onValidation);
    if (isComplete) {
      setDraftItem(undefined);
      sendUpdate([...committedRows, updatedDraft]);
    } else {
      setDraftItem(updatedDraft);
    }
  };
  const onRowUpdate = (rowData, index) => {
    if (draftItem && index === committedRows.length) {
      onDraftUpdate(rowData);
      return;
    }
    let shouldUpdate = true;
    const updated = value === null || value === void 0 ? void 0 : value.map((item, i) => {
      if (i !== index) {
        return item;
      }
      shouldUpdate = !isEqual(item, rowData);
      return _objectSpread(_objectSpread({}, item), rowData);
    });
    if (updated && shouldUpdate) {
      sendUpdate(updated);
    }
  };
  const onRowDelete = (_rowData, index) => {
    if (draftItem && index === committedRows.length) {
      setDraftItem(undefined);
      return;
    }
    if (index === undefined || !value) return;
    const updated = [...value];
    if (!updated) return;
    updated.splice(index, 1);
    sendUpdate(updated);
  };
  const errors = hasIncompleteRow ? [INCOMPLETE_ROW_ERROR, ...(errorMessage !== null && errorMessage !== void 0 ? errorMessage : [])] : errorMessage;
  return /*#__PURE__*/_jsxs("div", {
    ref: ref,
    children: [/*#__PURE__*/_jsx(EditTable, _objectSpread(_objectSpread({}, props), {}, {
      id: name,
      data: rows,
      selectedRow: selectedRow,
      selectRow: id => {
        if (id !== committedRows.length.toString()) {
          setDraftItem(undefined);
        }
        setSelectedRow(id);
      },
      sortBy: sortBy,
      onRowUpdate: onRowUpdate,
      onRowDelete: (data, index) => {
        if (!props.disableDelete) {
          onRowDelete(data, index);
        }
      },
      disableRowCheckBox: props.disableRowCheckBox,
      disableRowInputAutoFocus: props.disableRowInputAutoFocus,
      disableInvalidRowIndicator: props.disableInvalidRowIndicator
    })), !props.disabled && props.buildNewItem && /*#__PURE__*/_jsx(CommandBar, {
      "data-id": "".concat(name, "-commandbar"),
      items: [],
      farItems: [{
        key: 'create',
        name: 'Add',
        disabled: hasIncompleteRow || isAddDisabled,
        iconProps: {
          iconName: 'Add'
        },
        onClick: () => {
          onAddItem();
        }
      }]
    }), errors && touched && errors.map((error, index) => error && /*#__PURE__*/_jsx(FieldErrorMessage, {
      children: error
    }, "error".concat(index)))]
  });
};
export const EditTable = props => {
  return /*#__PURE__*/_jsx(InlineEditTable, _objectSpread({}, props));
};
const INCOMPLETE_ROW_ERROR = 'please complete row';
const areAllRowsValid = async (rows, inputList, onValidation) => {
  if (!onValidation) return true;
  try {
    await Promise.all(rows.map(data => onValidation({
      data,
      inputList
    })));
    return true;
  } catch (_unused) {
    return false;
  }
};